import React, { useContext, useEffect } from "react";
// @ts-ignore
import { initializePerformanceTheme } from "@vp/gatsby-theme-performance";
// @ts-ignore
import { fireImpression } from "@vp/ab-reader";
// @ts-ignore
import TrackingJS from "@vp/react-tracking";
import PageConfig from "../utils/PageConfig";
import { AnalyticsContext, ExperimentImpression } from "../contexts/AnalyticsContextProvider";
import { PageStaticDataContext } from "../contexts/PageStaticDataContextProvider";
import { analyticsPageData } from "../utils/analyticsConfig";

const Analytics = () => {
  const { experimentImpression, decision, setTrackingInitialized, analyticsPageName } = useContext(
    AnalyticsContext
  );
  const { locale, mpv, country } = useContext(PageStaticDataContext);
  const { mpvId, name: productName, coreProductId: productKey } = mpv;

  useEffect(() => {
    sendPageTracking();
  }, []);

  useEffect(() => {
    const sendOptimizelyImpression = async (impression?: ExperimentImpression) => {
      if (!impression) {
        return;
      }

      try {
        await fireImpression(impression.experimentKey, impression.variationKey, {
          pageName: analyticsPageName(mpvId),
          pageSection: analyticsPageData.pageSection,
          pageStage: analyticsPageData.pageStage,
        });
      } catch (e) {
        console.log(e);
      }
    };

    sendOptimizelyImpression(experimentImpression);
  }, [experimentImpression]);

  const sendPageTracking = () => {
    initializePerformanceTheme({
      route: "discovery",
      pageName: analyticsPageName(mpvId),
      pageSection: analyticsPageData.pageSection,
      pageStage: analyticsPageData.pageStage,
    });
    const windowTracking = window.tracking as any;
    if (windowTracking && windowTracking.page && windowTracking.track) {
      setTrackingInitialized(true);
      windowTracking.page({
        pageName: analyticsPageName(mpvId),
        pageSection: analyticsPageData.pageSection,
        pageStage: analyticsPageData.pageStage,
        genTrack: "Gatsby",
        language: `${locale.substring(0, 2)}`,
        locale: country,
        pageSegmentation: decision,
      });

      windowTracking.track("Product Viewed", {
        label: analyticsPageData.label,
        pageSection: analyticsPageData.pageSection,
        pageStage: analyticsPageData.pageStage,
        pageName: analyticsPageName(mpvId),
        product_id: `${mpvId}`,
        name: `${productName}`,
        core_product_id: `${productKey}`,
      });
    } else {
      setTimeout(() => sendPageTracking(), 1000);
    }
  };

  const environment = process.env.GATSBY_ENVIRONMENT === "prod" ? "prod" : "dev";
  const tenant = PageConfig.tenant;

  return (
    <TrackingJS
      tenant={tenant}
      culture={locale}
      environment={environment}
      integrations={{ All: true }}
    />
  );
};

export default Analytics;
